"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = require("@emotion/react");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var Tab = function Tab(_ref) {
  var _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex,
      _ref$onClick = _ref.onClick,
      _onClick = _ref$onClick === void 0 ? function () {
    return false;
  } : _ref$onClick,
      _ref$isActive = _ref.isActive,
      isActive = _ref$isActive === void 0 ? false : _ref$isActive,
      title = _ref.title,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "primary" : _ref$type,
      _ref$urlHash = _ref.urlHash,
      urlHash = _ref$urlHash === void 0 ? "" : _ref$urlHash,
      dataTestId = _ref.dataTestId;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var primaryBrand = theme.colors.primary.primaryBrand;
  var padding = "20px";
  var activeHeader = (0, react_1.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\tborder-bottom: 1px solid ", ";\n\t"])), primaryBrand);
  var tabHeaderStyle = (0, react_1.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\tcursor: pointer;\n\t\tpadding-top: ", ";\n\t\t", ";\n\t"])), padding, isActive ? activeHeader : null);
  var tabHeaderContainerStyle = (0, react_1.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\t\tpadding: 0px ", " 0px 0px;\n\t"])), padding);
  return (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
    className: "tab-header-container",
    direction: "column",
    css: tabHeaderContainerStyle,
    onClick: function onClick(e) {
      e.preventDefault();

      _onClick(tabIndex);
    },
    children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
      type: type,
      size: "md",
      dataTestId: dataTestId,
      children: title
    }), (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
      css: tabHeaderStyle
    })]
  });
};

exports.default = Tab;